import { createEffect } from 'effector';

export const fxUpdateAdditionalFieldsTicket = createEffect<
  Record<string, unknown>,
  void,
  Error
>();
